import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon, name, ...props }) => {
  let IconComponent;
  
  try {
    // We remove the dynamic FiIcons[`Fi${name}`] lookup that required 
    // a wildcard import (import * as FiIcons), as it forces the bundler
    // to load hundreds of files simultaneously, causing EMFILE errors.
    // Icons should be passed directly via the 'icon' prop.
    IconComponent = icon;
  } catch (e) {
    IconComponent = null;
  } 
  
  return IconComponent ? React.createElement(IconComponent, props) : <FiAlertTriangle {...props} />;
};

export default SafeIcon;